@if (isDeletable()) {
  <pas-button-round
    [color]="pasButtonRoundColor.DARK"
    (click)="onDelete($event)"
    icon="delete"
    size="small"></pas-button-round>
}
